<template>
  <div id="commonProblemPage">
	<plugin />
		<div v-for='item in helpList'  class='rowBox'>
			<div class="itemTitle">{{item[0].type==1?"新手指南":(item[0].type==2?"产品说明":(item[0].type==3?"支付方式及价格":(item[0].type==4?"跨境电商":(item[0].type==4?"物流售后":"物流售后"))))}}</div>
			<div v-for='itemQ in item' >

				<div class="item"  @click='handlemark(itemQ.id)' >
					<div class="q">
						<div class="Q">Q.</div>
						<div class="text"> {{itemQ.question}}</div>
						<img src="../assets/icon-next2.png" class="icon" :class='itemQ.mark?"icon2":""'  />
					</div>
					<div class="a" v-if='itemQ.mark'>{{itemQ.answer}}</div>
				</div>
			</div>
		</div>
		<div style='height:0.2rem;'></div>
  </div>
</template>

<script>


import plugin from '@/components/plugin.vue'
export default {
  name: 'commonProblem',
  components: {
	plugin
  },
  data() {
      return {
	   helpList:[],  
      }
    },
	created() {
	 
	  this.getProblem()
	},
    methods:{
		// 获取常见问题列表
		getProblem(){
			let that =this
				    	
			this.axios({
			            method: 'post',
			            url:"User/helpList?page=1",
			            data:{
			
			            }
					}).then(res=>{
						  
						        //   1: 新手指南,
						        //   2: 产品说明,
						        //   3: 支付方式及价格,
						        //   4: 跨境电商,
						        //   6: 物流售后,
						  
						  
			
						          that.helpList= res.data.helpList
					})
		},
		handlemark:function(eve){

		    let _helpList = this.helpList
			let _indexof = 0

		    for (let k in _helpList) {
		      _helpList[k].forEach((itemQ) => {
		          if (itemQ.id == eve) {
		            itemQ.mark = !itemQ.mark
		          }
		        })
		    } 
			// console.log(_indexof,_helpList[_indexof])
		 // this.$set(this.helpList, _indexof, _helpList[_indexof])
		 
		this.helpList = Object.assign({}, _helpList)
		 // this.$set( this.helpList, _indexof,_helpList[_indexof] )
		
		    
		},
		
    }
}
</script>
<style>
#commonProblemPage{
  background:rgba(244,242,240,1);
  width: 7.5rem;
  height: 100vh;
  position:relative;
  margin: 0 auto;
  background-color: #fff;
  overflow-y: auto;
  
}
#commonProblemPage::-webkit-scrollbar {display:none}



#commonProblemPage .item {
    padding:0.1rem 0.25rem;
    padding-left: 0.4rem;
	box-sizing: content-box;
    position: relative;
    text-align: left;
}
/* .questions .item:after {
    position: absolute;
    content: "";
    left: 40rpx;
    right: 0;
    height: 1px;
    bottom: 0;
    background: #E5E5E5;
} */
#commonProblemPage .item .q {

    display: flex;
    /* justify-content: space-between; */
    font-size: 0.3rem;
    position: relative;
}
#commonProblemPage .item .q .text{
  width: 6rem;
  font-size:0.3rem;
}
.Q{
  width: 0.5rem;
}
#commonProblemPage .item .q .icon {
    width: 0.15rem;
    height: 0.25rem;
    margin: 0.08rem 0 0 0.2rem;
    z-index: 9;
    position: absolute;
    top:0.05rem;
    right: 0.05rem;

}
.icon2{
	transform: rotate(90deg) ;
}
#commonProblemPage .item .a {
    font-size: 0.3rem;
    line-height: 0.45rem;
    color: #555555;
    padding-left: 0.5rem;
    padding-top: 0.2rem;
    padding-right: 0.4rem;
}
.itemTitle{
  padding:0.25rem 0.35rem 0.1rem;
  font-weight: bold;
  font-size: 0.32rem;
  box-sizing: content-box;
}
.rowBox{
border-bottom: 1px solid #E5E5E5;
padding-bottom: 0.2rem;
box-sizing: content-box;
text-align: left;
}



</style>